'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" fillRule="evenodd" d="M6.305 3.564c0 1.426-1.024 2.566-2.668 2.566h-.03C2.023 6.13 1 4.99 1 3.564 1 2.11 2.055 1 3.668 1S6.274 2.11 6.305 3.564m-.31 4.592V23H1.278V8.156zM23 23v-8.511c0-4.56-2.326-6.682-5.43-6.682-2.503 0-3.624 1.441-4.25 2.452V8.156H8.604c.063 1.393 0 14.844 0 14.844h4.716v-8.29c0-.443.031-.886.156-1.203.34-.887 1.116-1.804 2.42-1.804 1.706 0 2.389 1.36 2.389 3.355V23z" clipRule="evenodd" /></svg>;
const IconSocialLinkedin = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconSocialLinkedin;